import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const neon: Partial<CaptionStyles> = {
  theme_preset: 'neon',
  pageStyle: {
    color: '#01e9ed',
    WebkitTextStrokeWidth: '3px',
    WebkitTextStrokeColor: '#009b9e',
    paintOrder: 'stroke',
    textShadow: '10px 10px 29px #0ad8db'
  },
  wordStyle: {
    active: {
      color: '#01e9ed'
    },
    inactive: {
      color: '#01e9ed'
    },
    highlightType: HighlightTypeEnum.Text
  },
  letterStyle: undefined,
  font_location: getFontFullPath('TitanOne-Regular.ttf'),
  caps: true,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    wordIn: TransitionInEffect.SlideUp
  }
};

export default neon;
